export default class SettingsMenuService {
    constructor(
        $state,
        $sbCurrentProject,
        $sbPageAccess,
        $sbFeatureDecisions,
        PageFlags,
        SABLONO_STATES
    ) {
        "ngInject";

        this.$state = $state;
        this.$sbCurrentProject = $sbCurrentProject;
        this.$sbPageAccess = $sbPageAccess;
        this.$sbFeatureDecisions = $sbFeatureDecisions;
        this.PageFlags = PageFlags;
        this.SABLONO_STATES = SABLONO_STATES;
    }

    getDisabledReason(targetState) {
        const project = this.$sbCurrentProject.get();
        const isAccessible = this.$sbPageAccess.isAccessible(
            targetState,
            project?.privileges
        );
        const isProjectSettingsTarget =
            targetState === this.SABLONO_STATES.projectSettings;

        if (isProjectSettingsTarget) {
            const isCurrentStateProjectScoped =
                this.SABLONO_STATES.isProjectState(this.$state.current.name);

            if (!isCurrentStateProjectScoped || !project) {
                return "SETTINGS_MENU_SELECT_PROJECT_HINT";
            }
            if (
                !isAccessible &&
                !this.$sbFeatureDecisions.isFeatureEnabled(
                    this.PageFlags.ProjectSettings
                )
            ) {
                return "SETTINGS_MENU_PROJECT_SETTINGS_UNAVAILABLE_HINT";
            }
        }

        if (isAccessible) {
            return undefined;
        }

        return "SETTINGS_MENU_ACCESS_DENIED_HINT";
    }

    navigate(targetState) {
        if (this.getDisabledReason(targetState)) {
            return;
        }

        const isProjectSettingsTarget =
            targetState === this.SABLONO_STATES.projectSettings;

        if (isProjectSettingsTarget) {
            const project = this.$sbCurrentProject.get();

            return this.$state.go(targetState, { projectId: project.id });
        }

        return this.$state.go(targetState, {});
    }
}
